export enum StateType {
  toCurate = 'toCurate',
  reject = 'reject',
  approve = 'approve'
}
